import { Registration } from '@stax-core/types-omni';

export const forteMapper = (r: Registration) => ({});
